import { Tag } from 'antd';
import styled from 'styled-components';

import { CSS_PREFIX } from '@/constants';
import {
  BlueColors,
  GreenColors,
  NeutralColors,
  OrangeColors,
  ParentSeedsBatchInventoryStatusColors,
  PinkColors,
  PurpleColors,
  RedColors,
  TealColors,
  YellowColors
} from '@/theme';

export const StatusTag = styled(Tag)`
  &&.${CSS_PREFIX}-tag-red {
    background: ${RedColors[20]};
    color: ${RedColors[60]};
  }

  &&.${CSS_PREFIX}-tag-red-inverse {
    background: ${RedColors[60]};
  }

  &&.${CSS_PREFIX}-tag-orange {
    background: ${OrangeColors[20]};
    color: ${OrangeColors[70]};
  }

  &&.${CSS_PREFIX}-tag-orange-inverse {
    background: ${OrangeColors[60]};
  }

  ${({ color }) =>
    color === 'orange-darker' &&
    `
    && {
      background: ${OrangeColors[20]};
      color: ${OrangeColors[60]};
    }
  `}

  ${({ color }) =>
    color === 'orange-darker-inverse' &&
    `
    && {
      background: ${OrangeColors[70]};
    }
  `}

  &&.${CSS_PREFIX}-tag-yellow {
    background: ${YellowColors[20]};
    color: ${YellowColors[70]};
  }

  &&.${CSS_PREFIX}-tag-yellow-inverse {
    background: ${YellowColors[60]};
  }

  &&.${CSS_PREFIX}-tag-green {
    background: ${GreenColors[20]};
    color: ${GreenColors[70]};
  }

  &&.${CSS_PREFIX}-tag-green-inverse {
    background: ${GreenColors[60]};
  }

  &&.${CSS_PREFIX}-tag-cyan {
    background: ${TealColors[20]};
    color: ${TealColors[70]};
  }

  &&.${CSS_PREFIX}-tag-cyan-inverse {
    background: ${TealColors[60]};
  }

  &&.${CSS_PREFIX}-tag-blue {
    background: ${BlueColors[20]};
    color: ${BlueColors[70]};
  }

  &&.${CSS_PREFIX}-tag-blue-inverse {
    background: ${BlueColors[60]};
  }

  &&.${CSS_PREFIX}-tag-purple {
    background: ${PurpleColors[20]};
    color: ${PurpleColors[70]};
  }

  &&.${CSS_PREFIX}-tag-purple-inverse {
    background: ${PurpleColors[70]};
  }

  &&.${CSS_PREFIX}-tag-pink {
    background: ${PinkColors[20]};
    color: ${PinkColors[70]};
  }

  &&.${CSS_PREFIX}-tag-pink-inverse {
    background: ${PinkColors[70]};
  }

  ${({ color }) =>
    color?.includes('inverse') &&
    `
    border: transparent;
  `}

  ${({ color }) =>
    color === 'neutral' &&
    `
    && {
      background: ${NeutralColors[10]};
      color: ${NeutralColors[60]};
    }
  `}

  ${({ color }) =>
    color === 'neutral-inverse' &&
    `
    && {
      background: ${NeutralColors[60]};
      color: ${NeutralColors[0]};
    }
  `}

  ${({ color }) =>
    color === 'red-darker' &&
    `
    && {
      background: ${RedColors[20]};
      color: ${RedColors[70]};
    }
  `}

  ${({ color }) =>
    color === 'red-darker-inverse' &&
    `
    && {
      background: ${RedColors[70]};
    }
  `}

  ${({ color }) =>
    color === 'neutral-darker' &&
    `
    && {
      background: ${NeutralColors[20]};
      color: ${NeutralColors[70]};
    }
  `}

  ${({ color }) =>
    color === 'neutral-darker-inverse' &&
    `
    && {
      background: ${NeutralColors[70]};
    }
  `}

  ${({ color }) =>
    color === 'batch-unassigned' &&
    `
    && {
      background: ${ParentSeedsBatchInventoryStatusColors.unassigned.background};
      color: ${ParentSeedsBatchInventoryStatusColors.unassigned.text};
    }
  `}

  ${({ color }) =>
    color === 'batch-partial' &&
    `
    && {
      background: ${ParentSeedsBatchInventoryStatusColors.partial.background};
      color: ${ParentSeedsBatchInventoryStatusColors.partial.text};
    }
  `}

  ${({ color }) =>
    color === 'batch-full' &&
    `
    && {
      background: ${ParentSeedsBatchInventoryStatusColors.full.background};
      color: ${ParentSeedsBatchInventoryStatusColors.full.text};
    }
  `}

  /* The only bordered variant: its stroke must beat antd's borderless rule. */
  ${({ color }) =>
    color === 'neutral-darkest' &&
    `
    && {
      background: ${NeutralColors[90]};
      border: 1px solid ${NeutralColors[60]};
      color: ${NeutralColors[20]};
    }
  `}

  font-weight: 600;

  /* A status column sizes to its labels; an over-long one must not widen it. */
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
`;
